<template>
  <main class="charts">

    <div class="static-charts">

      <div class="cards">
        <div class="card-statistic">
          <app-statistic-card data-name="connectedUsers"
                              :data-heading="$t('message.overview.message.connectedUsers')"
                              data-attachment="" />
        </div>
        <div class="card-statistic">
          <app-statistic-card data-name="engagement"
                              :data-heading="$t('message.statistics.message.engagement')"
                              data-attachment="%" />
        </div>
        <div class="card-statistic">
          <app-statistic-card data-name="rejection"
                              :data-heading="$t('message.statistics.message.rejection')"
                              data-attachment="%" />
        </div>
      </div>

      <app-chart class="half-width"
                 :loading="loading"
                 :totalLabels="[this.$t('message.generics.message.accesses'),this.$t('message.statistics.message.abandonment')]"
                 data-name="access"
                 data-type="line"
                 :data-heading="$t('message.generics.message.accesses')"
                 :data-tooltip="$t('message.statistics.message.tooltipAccesses')"
                 showTotal />

      <app-chart class="half-width"
                 :loading="loading"
                 :totalLabels="[this.$t('message.statistics.message.uniqueUsers'),this.$t('message.statistics.message.newUsers')]"
                 data-name="clients"
                 data-type="line"
                 :data-heading="$t('message.generics.message.users')"
                 :data-tooltip="$t('message.statistics.message.tooltipUsers')"
                 showTotal />

      <app-chart class="half-width"
                 :loading="loading"
                 :totalLabels="[this.$t('message.statistics.message.impressions'),this.$t('message.statistics.message.viewability')]"
                 data-name="impressions"
                 data-type="line"
                 :data-heading="$t('message.statistics.message.impressions')"
                 :data-tooltip="$t('message.statistics.message.tooltipImpressions')"
                 showTotal />

      <app-chart :loading="loading"
                 class="half-width"
                 data-name="weekday"
                 data-type="bar"
                 :data-heading="$t('message.statistics.message.accessesByDay')"
                 :data-tooltip="$t('message.statistics.message.tooltipAccessesByDay')" />

      <app-chart class="full-width"
                 :loading="loading"
                 data-name="accessHour"
                 data-type="line"
                 :data-heading="$t('message.statistics.message.accessesByHour')"
                 :data-tooltip="$t('message.statistics.message.tooltipAccessesByHour')" />

      <app-chart class="full-width"
                 :loading="loading"
                 data-name="totalUser"
                 data-type="line"
                 :data-heading="$t('message.statistics.message.totalUsers')"
                 :data-tooltip="$t('message.statistics.message.tooltipTotalUsers')" />

      <app-chart :loading="loading"
                 class="third-width"
                 data-name="deviceType"
                 data-type="doughnut"
                 :data-heading="$t('message.statistics.message.devices')"
                 :data-tooltip="$t('message.statistics.message.tooltipDevices')" />

    </div>

  </main>
</template>

<script>
    import loadsOnFilterUpdate from '@mixins/loads-on-filter-update'
    import AppChart from '@components/chart/Chart'
    import AppStatisticCard from '@components/StatisticCard'

    export default {
        components: {
            AppChart,
            AppStatisticCard
        },

        data() {
            return {
              loading: false,
              loadOnFilters: false
            }
        },

        computed: {
            locale() {
                return this.$store.state.users.locale
            },

            filters() {
                return this.$store.state.statistics.filters
            },
        },

        watch: {
            locale() {
                this.load()
            }
        },

        methods: {
            chartKey(chart) {
                return `${chart.interacao.id}-${this.$date.timestamp()}`
            },
            async load() {
              this.loading = true

              await this.$loader.statistics.overviewAdmin(this.filters)

              this.loading = false
            }
        },

        destroyed() {
            this.$store.commit('STATISTICS_RESET_FILTERS')
        },

        mounted() {
            this.load()
        },

        mixins: [loadsOnFilterUpdate]
    }
</script>

<style lang="scss" scoped>
.charts {
  width: 98% !important;
  & > * {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    & > * {
      margin-bottom: 30px;
    }
  }

  .static-charts {
    .cards {
      width: 100%;
      display: flex;
      flex-wrap: inherit;

      & > * {
        flex: 1;
        height: 170px;
        margin-bottom: 20px;
      }

      .card-statistic {
        padding: 8px;

        &:last-child {
          padding-right: 0;
        }

        &:first-child {
          padding-left: 0;
        }
      }
    }
  }

  .half-width {
    width: calc(50% - 15px) !important;
  }

  .third-width {
    width: calc(33.33% - 22px) !important;
  }

  .fourth-width {
    width: calc(25% - 12px) !important;
  }
}
</style>
